import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
  
})
export class FooterComponent implements OnInit {

  year: string;

  ShowFooter$: boolean = true;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.year = new Date().getFullYear().toString();

    this.route.queryParams.subscribe((params) => {
      let hideNav = params['hidenav'];

      if (hideNav == 'true') {
        this.ShowFooter$ = false;
      }

    });
  }


}
